module.exports = __webpack_public_path__ + "media/images/catalogs/items/options/icons/house_cleaning_products-ccf400652a1f4dea9c494d6c045c3564.svg";